import { all } from "redux-saga/effects";

function* dataSaga() {
  yield all([
  ]);
}

export default dataSaga;
